import { Link } from "@circleco/compass/components/Link";

import { t } from "@/i18n-js/instance";
import { Button } from "@/react/components/SettingsApp/CompassCompat/Button";

import { OtpSecurityBadge } from "./OtpSecurityBadge";

interface OtpFooterProps {
  allowResend: boolean;
  handleResend: () => void;
  isLoading: boolean;
  onSignInWithPassword?: () => void;
  onSkip?: () => void;
  showSignInWithPassword?: boolean;
}

export const OtpFooter = ({
  handleResend,
  allowResend,
  isLoading,
  showSignInWithPassword = false,
  onSignInWithPassword,
  onSkip,
}: OtpFooterProps) => (
  <div className="flex flex-col gap-3">
    <div className="flex items-center justify-between gap-4">
      <div className="flex items-center gap-4">
        {allowResend ? (
          <Link asButton size="sm" onClick={handleResend} disabled={isLoading}>
            {t("otp_challenge_modal.resend_code")}
          </Link>
        ) : (
          <Link
            href={t("otp_challenge_modal.experiencing_issues.link")}
            target="_blank"
            rel="noopener noreferrer"
            size="sm"
            aria-label={t(
              "otp_challenge_modal.experiencing_issues.link_aria_label",
            )}
          >
            {t("otp_challenge_modal.experiencing_issues.link_text")}
          </Link>
        )}
        {showSignInWithPassword && (
          <Link asButton size="sm" onClick={onSignInWithPassword}>
            {t("otp_challenge_modal.sign_in_with_password")}
          </Link>
        )}
      </div>
      {onSkip && (
        <Button variant="secondary" type="button" onClick={onSkip}>
          {t("otp_challenge_modal.skip")}
        </Button>
      )}
    </div>
    <OtpSecurityBadge />
  </div>
);

OtpFooter.displayName = "OtpFooter";
